import React from 'react'

import classes from './Footer.scss'

import Button from '../../../../UI/Button/Button'
import { withTranslate } from 'react-redux-multilingual'

const footer = ({ saveClicked, cancelClicked, translate }) => {
  return (
    <div className={classes.Footer}>
      <div className={classes.Button}>
        <Button color={'primary'} className={classes.Button} clicked={saveClicked}>
          {translate('save')}
        </Button>
      </div>
      <div className={classes.Button}>
        <Button color={'default'} className={classes.Button} clicked={cancelClicked}>
          {translate('cancel')}
        </Button>
      </div>
    </div>
  )
}

export default withTranslate(footer)
